import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

const getClass = ({ cancelled, quantity_received: qtyReceived, quantity }) =>
  classNames({
    "green-table-cap": !cancelled && quantity === qtyReceived,
    "warning-table-cap": !cancelled && quantity !== qtyReceived,
    "danger-table-cap": cancelled
  });

export default function PurchaseOrderLineItemStatusCell({
  lineItem,
  children
}) {
  return <td className={getClass(lineItem)}>{children}</td>;
}

PurchaseOrderLineItemStatusCell.propTypes = {
  lineItem: PropTypes.shape({
    cancelled: PropTypes.boolean,
    quantity: PropTypes.number.isRequired
  }).isRequired,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node)
  ])
};



// WEBPACK FOOTER //
// ./app/modules/shared/components/PurchaseOrderLineItemStatusCell/PurchaseOrderLineItemStatusCell.jsx